import { arrayUniqueByKey } from 'utils/data/listHelpers';
import { DataTableColumnConfigurationModel } from '@utmost.co/enterprise-models';
import { DataTableColumnConfiguration, DataTableKey } from './ColumnConfiguration.types';

export const updateAllColumnConfigs = (
  allConfigs: DeepPartial<DataTableColumnConfigurationModel>[] | undefined,
  currentConfig: DataTableColumnConfiguration,
  dataTableKey: DataTableKey
): DeepPartial<DataTableColumnConfigurationModel>[] =>
  arrayUniqueByKey(
    [...(allConfigs || []), { ...currentConfig, key: dataTableKey }],
    'key'
  ) as DeepPartial<DataTableColumnConfigurationModel>[];
